import { useEffect, useState } from 'react';

const useDebounce = (value: string | number, delay: number = 500): any => {
  const [debounceValue, updateDebounceValue] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => {
      updateDebounceValue(value);
    }, delay);
    return () => {
      clearTimeout(id);
    };
  }, [value, delay]);

  return debounceValue;
};

export default useDebounce;
